module.exports = __webpack_public_path__ + "img/folder3.59248360.png";